import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '../../Box/Box';
import { Icon as DSIcon } from '../../Icon/Icon';
export const Icon = ({ icon, size }) => {
    return (_jsx(Box, { mr: 'xs', children: _jsx(DSIcon, { color: 'neutral-400', name: icon, size: size }) }));
};
